import { Trans as OriginTrans } from 'next-i18next';

import type { ComponentProps } from 'react';

type TransProps = ComponentProps<typeof OriginTrans>;

const Trans = (props: TransProps) => {
  return <OriginTrans {...props} />;
};

export default Trans;

export type { TransProps };
